/**
 * Form field validators for the Microservice Generator
 */

export interface ValidationResult {
    isValid: boolean;
    error: string;
}

// Required field validator
export const requiredValidator = (value: string, fieldName: string = 'This field'): string => {
    if (!value || !value.trim()) {
        return `${fieldName} is required`;
    }
    return '';
};

// Service name validator
export const serviceNameValidator = (value: string): string => {
    if (!/^[a-zA-Z0-9\s-_]+$/.test(value.trim())) {
        return 'Service name can only contain alphanumeric characters, spaces, hyphens, and underscores';
    }
    return '';
};

// Repo branch validator (for template and deploy repo branches)
export const repoBranchValidator = (value: string): string => {
    if (!/^[a-zA-Z0-9\-_]+$/.test(value.trim())) {
        return 'Repo branch can only contain alphanumeric characters, hyphens, and underscores';
    }
    return '';
};

// Maintainer teams validator (async validation will be handled in the hook)
export const maintainerTeamsValidator = (value: string): string => {
    if (!value || !value.trim()) {
        return 'At least one maintainer team is required';
    }
    // Basic format validation for comma-separated teams
    const teams = value.split(',').map(team => team.trim()).filter(team => team.length > 0);
    if (teams.length === 0) {
        return 'At least one maintainer team is required';
    }
    return '';
};

// Min length validator
export const minLengthValidator = (value: string, minLength: number): string => {
    if (value.trim().length < minLength) {
        return `Must be at least ${minLength} characters`;
    }
    return '';
};

// Max length validator
export const maxLengthValidator = (value: string, maxLength: number): string => {
    if (value.trim().length > maxLength) {
        return `Cannot exceed ${maxLength} characters`;
    }
    return '';
};

// Combined validator function
export const validateField = (
    value: string,
    validators: Array<(value: string) => string>
): string => {
    for (const validator of validators) {
        const error = validator(value);
        if (error) {
            return error;
        }
    }
    return '';
};
